import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {environment as ENV} from '../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService, ExclusionService, Events, NetworkService} from '../../services/services';
import {LoaderService} from '../../services/loader/loader.service';
import {finalize} from 'rxjs/operators';
import {
  IonBackButton, IonButton,
  IonContent, IonFooter,
  IonHeader, IonInput, IonItem, IonLabel,
  IonList,
  IonToolbar
} from "@ionic/angular";
import {FormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-reminder',
  templateUrl: './reminder.page.html',
  styleUrls: ['./reminder.page.scss'],
  imports: [
    IonHeader,
    IonToolbar,
    IonBackButton,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonInput,
    FormsModule,
    NgClass,
    IonFooter,
    IonButton
  ],
  standalone: true
})
export class ReminderPage{
  config = ENV;
  isSubmitting = false;

  account: { email: string} = {
    email: ''
  };
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public networkServ: NetworkService,
    public api: ApiService,
    private loader: LoaderService
  ) {
    this.route.queryParams.subscribe(params => {
      if (params['account']) {
        // console.log('params', params);
        // console.log(params['account']);
        // const paramData = JSON.parse(params['account']);
        const paramData = JSON.parse(params['account'])
        this.account.email = paramData.email;
        console.log('params', paramData.account.email);
        console.log('this.account', this.account);
      }

    });
  }

  //@ts-ignore
  async doReminder() {
    if (this.isSubmitting) {
      return false;
    }

    this.isSubmitting = true;
    this.loader.show();

    let conn: any;
    try {
      //internet connection check
      conn = await this.networkServ.checkInternet();
    } catch (err) {
      this.isSubmitting = false;
      this.loader.hide();
      return false;
    }

    if (!conn.result) {
      this.isSubmitting = false;
      this.loader.hide();
      return false;
    }

    // register the user
    this.api.remindUser(this.account)
      .pipe(finalize(() => {
        this.isSubmitting = false;
        this.loader.hide();
      }))
      .subscribe((item) => {
        console.log('Reminder Success: ');
        this.router.navigate(['email-reminder']);
      }, (err) => {
        console.log('Reminder failure: ');
        this.router.navigate(['email-reminder']);
      });
  }

}
